import { generateNumbers } from "@/utils/math";
import { EChartsOption, graphic, LineSeriesOption } from "echarts";
export type PlayStatus = "play" | "pause" | "stop";
export const getDefaultSeriesData = () => {
  const res = {
    // 左前轮实际制动力
    UIRx_WhlBrkTqAct_FL_BCh1: [],
    // 右前轮实际制动力
    UIRx_WhlBrkTqAct_FR_BCh1: [],
    // 左后轮实际制动力
    UIRx_WhlBrkTqAct_RL_BCh1: [],
    // 右后轮实际制动力
    UIRx_WhlBrkTqAct_RR_BCh1: [],
    // 驾驶员制动意图
    UIRx_DrvrReqTrgtFxBrk_Bch1: [],
    // 车辆静止信号
    UIRx_VehSdsl: [],
    // 纵向减速度
    UIRx_ACULongdAcc: [],
    // 车辆俯仰角，VDM 通过四个悬架高度信号计算
    UIRx_PitchAng: [],
    // 参考车速
    UIRx_VehSpd: [],
  } as DomianControl.CSTSeriesData;
  return res;
};
export const decreasingSequence = generateNumbers(6);
export const getTitle = ($q: any) =>
  ({
    top: 5,
    left: 0,
    textStyle: {
      color: $q.dark.isActive ? "#bdbdbd" : "#032f2b",
      fontSize: 14,
    },
  } as EChartsOption["title"]);
export const getTitle2 = ($q: any) =>
  ({
    top: 5,
    left: 0,
    // bottom:10,
    textStyle: {
      color: $q.dark.isActive ? "#bdbdbd" : "#032f2b",
      fontSize: 14,
    },
  } as EChartsOption["title"]);
export const getTitle3 = ($q: any) =>
  ({
    top: 5,
    left: 15,
    // bottom:10,
    textStyle: {
      color: $q.dark.isActive ? "#bdbdbd" : "#032f2b",
      fontSize: 14,
    },
  } as EChartsOption["title"]);
export const getGrid = () => ({
  top: 50,
  left: 50,
  right: 60,
  bottom: 40,
});
// 获取图表的默认配置
export const getChartsDefaultOptions = (value: number) => {
  const TP_value = Math.floor(value / 100);
  const gradientConfigs = {
    gt120: {
      offsets: [0, 0.01, 0.1, 0.2, 0.3, 0.5, 0.8, 0.9, 1],
      colors: [
        "#FF6666",
        "#FF6666",
        "#FF6666",
        "#FF9999",
        "#93FE94",
        "#93FE94",
        "#B0B0B0",
        "#A8A8A8",
        "#a1a1a1",
      ],
    },
    gt100: {
      offsets: [0.01, 0.1, 0.3, 0.5, 0.8, 0.9, 1],
      colors: [
        "#FF6666",
        "#FF9999",
        "#93FE94",
        "#93FE94",
        "#B0B0B0",
        "#A8A8A8",
        "#a1a1a1",
      ],
    },
    gt90: {
      offsets: [0, 0.1, 0.3, 0.5, 0.8, 0.9, 1],
      colors: [
        "#FF6666",
        "#FF9999",
        "#93FE94",
        "#93FE94",
        "#B0B0B0",
        "#A8A8A8",
        "#a1a1a1",
      ],
    },
    gt40: {
      offsets: [0, 0.3, 0.6, 0.8, 1],
      colors: ["#93FE94", "#93FE94", "#C0C0C0", "#A8A8A8", "#a1a1a1"],
    },
    default: {
      offsets: [0, 0.6, 1],
      colors: ["#C0C0C0", "#A8A8A8", "#a1a1a1"],
    },
  };

  const rangeKey =
    TP_value > 120
      ? "gt120"
      : TP_value > 100
      ? "gt100"
      : TP_value > 90
      ? "gt90"
      : TP_value > 40
      ? "gt40"
      : "default";

  const { offsets, colors } = gradientConfigs[rangeKey];
  const Gradient = [];
  function generateGradientKeyframes(offsets: any, colors: any) {
    const keyframes = [];
    for (let i = 0; i < offsets.length; i++) {
      keyframes.push({
        offset: offsets[i],
        color: colors[i],
      });
    }
    return keyframes;
  }

  Gradient.push(...generateGradientKeyframes(offsets, colors));
  const option = {
    animation: false,
    backgroundColor: "rgba(0,0,0,0.0)",
    grid: {
      top: "13%",
      left: "24%",
      right: "0%",
      bottom: "3%",
    },
    tooltip: {
      show: false,
    },
    xAxis: {
      data: [],
      axisLine: {
        lineStyle: {
          color: "transparent", //底部边框颜色
        },
      },
      axisLabel: {
        textStyle: {
          color: "#fff", //底部文字颜色
          fontSize: 12,
        },
      },
      splitLine: {
        show: false,
      },
    },
    yAxis: [
      {
        type: "value",
        max: 14000,
        splitLine: {
          show: false,
          lineStyle: {
            color: "rgba(255,255,255,0.2)", //网格线的颜色
            width: 1,
            type: "solid",
          },
        },
        axisLine: {
          show: false,
          lineStyle: {
            color: "transparent", //左边框颜色
          },
        },
        axisLabel: {
          show: false,
          fontSize: 12,
          textStyle: {
            color: "#ADD6FF", //左文字颜色
          },
        },
      },
    ],
    series: [
      {
        name: "协商议题类型比例",
        type: "bar",
        barWidth: 70,
        showBackground: true,
        backgroundStyle: {
          color: "rgba(198, 198, 198,0.2)",
        },
        itemStyle: {
          normal: {
            color: new graphic.LinearGradient(0, 0, 0, 1, Gradient),
          },
        },
        data: [value],
        z: 0,
        zlevel: 0,
      },
      {
        type: "pictorialBar",
        barWidth: 70,
        itemStyle: {
          normal: {
            color: "rgba(198, 198, 198,0.4)", //数据的间隔颜色
          },
        },
        symbolRepeat: "fixed",
        symbolMargin: 2,
        symbol: "rect",
        symbolSize: [60, 4],
        symbolPosition: "end",
        symbolOffset: [0, 0],
        data: [value],
        z: 1,
        zlevel: 0,
      },
      {
        type: "pictorialBar",
        barWidth: 70,
        itemStyle: {
          normal: {
            color: "transparent", //数据的间隔颜色
          },
        },
        // symbolRepeat: 'fixed',
        symbolMargin: 2,
        symbol: "rect",
        symbolSize: [70, 4],
        data: [value],
        z: 1,
        zlevel: 0,
        label: {
          show: false,
          position: "top",
          fontSize: 14,
          color: "#fff", //柱状顶部文字颜色
          formatter: function (params) {
            // return '20%';
          },
        },
      },
    ],
  } as EChartsOption;

  return option;
};
export const getChartsDefaultOptions2 = (value: number) => {
  var PatternSrc =
    "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACcAAACyAgMAAAC8Zj5WAAAADFBMVEU1mcQAAAA1mcQ1mcQFya0nAAAABHRSTlMZAAkRJfDlNAAAAFtJREFUOMtjCIWBEAYyAcIEkpikgDMGh3nAyIAkK1bBwAqSbPsPA39Ism03DOwgyTaEI0myDeFIWtk2NJIGfW07bwwFNvRIiIgUNZoQB33SQIBBXEaNJsQhmRABdkqh2Grn4rYAAAAASUVORK5CYII=";
  var PatternImg = new Image();
  PatternImg.src = PatternSrc;

  var fillSrc =
    "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAF+CAMAAADz+WkdAAAAY1BMVEUAAAA00Lw92bE41LdD36lJ5aJV8JRb9Y1N6Z1R7ZhY85BZ9I8207kyz75b9o000bw51bZX8pJV8JRA3K1N6Z1Q7JlL56BT7pdC3qs717NE4Kg82LI+2rBG4aZI46RJ5aJP6pvNrsJWAAAAC3RSTlMA5+fn5+fn5+fn5wyCdZUAAAFNSURBVHja7dLrboJQEEXhkZuKqK2giNe+/1O2L9BkVtJjD+P++L1CBrYtd4ztAgT4aHHQlrSlP7PcMLYJEOCjxaPN70+nD1pt6cf/b+kTyjFoaSAeTX5/On3QaEspNAfGDgECfLRksqWRPS94QzMyJh7rkbExQLDWllJYHxk7Bgjw0TLTLX1BPFjRQDxWA2NDgAAfLTPd0gmy08AeW9E3RFDjzxogqN/xT6dXPxl7Bgjw0eJRPxh7BAjw0eJR3xm7BwgqGohHdWHsEiDAR0uSLZ2hHIOKBuJRJf9xPWTnnj38DRUNxKPoGesDBIW2lEJxY+wWIMBHi0dxZewaIMBHi0cxMTYFCPDR4lFOjH1AOQYlDcSjzO9Pa0szVXaMdQECfLRoS78EC20phcWesT0OOvYYfwPEj5ZMtpRfoC0lsdgytg0Q4KNFW9KWXugb9rK+ibjhjhMAAAAASUVORK5CYII=";
  var fillImg = new Image();
  fillImg.src = fillSrc;
  const max = 14000;
  var data = [
    {
      name: "",
      value: Math.floor((value || 0) / 50) * 50,
    },
  ];
  var option = {
    animation: false,
    backgroundColor: "rgba(0,0,0,0.0)",
    grid: {
      left: "0%",
      right: "0%",
      bottom: "0%",
      // 设置是否包含坐标轴标签在网格内，这里设置为true
      containLabel: true,
    },
    yAxis: [
      {
        type: "value",
        max,
        show: false,
        splitLine: {
          show: false,
        },
        axisLine: {
          show: false,
        },
        axisTick: {
          show: false,
        },
      },
    ],
    xAxis: [
      {
        type: "category",
        data: [""],
        boundaryGap: ["20%", "20%"],
        splitLine: {
          show: false,
        },
        axisLine: {
          show: false,
        },
        axisTick: {
          show: false,
        },
      },
    ],
    series: [
      {
        name: "驾驶员制动力",
        type: "bar",
        stack: "samesign",
        z: 3,
        barWidth: "45%",
        barHeight: "100%",
        data: data,
        itemStyle: {
          color: { image: fillImg, repeat: "repeat" },
        },
        graphic: {
          elements: [
            {
              type: "image",
              style: {
                image: fillImg,
                x: 0,
                y: 0,
                width: "100%",
                height: "10%", // 设置图片高度为柱状图高度的80%，可根据需求调整此比例
                z: 1,
              },
            },
          ],
        },
      },
      {
        name: "占位",
        type: "bar",
        barWidth: "45%",
        barGap: "-100%",
        silent: true,
        z: 1,
        label: {
          show: false,
        },
        itemStyle: {
          color: { image: PatternImg, repeat: "repeat" },
        },
        data: [max],
      },
    ],
  };
  return option;
};
export const optionseries1 = () => [
  {
    id: "1",
    name: "目标制动力",
    color: "#e80000",
  },
  {
    id: "2",
    name: "实际制动力",
    color: "#0372bf",
  },
];
export const optionseries2 = () => [
  {
    id: "3",
    name: "目标制动力",
    color: "#ed1c24",
  },
  {
    id: "4",
    name: "实际制动力",
    color: "#0372bf",
  },
];
export const optionseries3 = () => [
  {
    id: "1",
    name: "功能开启",
    color: "#43a047",
  },
  {
    id: "2",
    name: "功能关闭",
    color: "#455a64",
  },
];
export const optionseries4 = () => [
  {
    id: "1",
    name: "功能开启",
    color: "#e8ba00",
  },
  {
    id: "2",
    name: "功能关闭",
    color: "#37474f",
  },
];
export const getDefaultSeriesProp = () =>
  ({
    type: "line",
    showSymbol: false,
    symbol: "circle",
    symbolSize: 6,
    lineStyle: {
      width: 2,
    },
    clip: true,
    data: [],
  } as LineSeriesOption);
